export const brandOverlayDataUrl = {
  type: "string",
  minLength: 1,
  maxLength: 2_048
};
